import React from "react";

import { DateTime } from "luxon";

import Typography from "@mui/material/Typography";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";
import Stack from "@rui/Stack";

const RemovePaymentConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  inTrialPeriod,
  currentPeriodEnd,
  currentPlanLabel,
  hasScheduledPlan,
}: ConfirmationModalProps & {
  inTrialPeriod: boolean;
  currentPeriodEnd?: string;
  currentPlanLabel: string | null;
  hasScheduledPlan: boolean;
}) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Remove Payment Method?"
      cancelProps={{ label: "Keep my card" }}
      confirmProps={{ label: "Remove & Cancel", type: "negative" }}
      loading={loading}
    >
      <Stack spacing={2}>
        {inTrialPeriod ? (
          <Typography variant="bodyPrimaryReg">
            {hasScheduledPlan
              ? "Your account will be downgraded to the Free plan at the end of your trial. If you don't want to lose access to critical features, you can update your billing information before your trial ends."
              : "Your payment method will be removed. You may add a new payment method at any time in the future."}
          </Typography>
        ) : (
          <Typography variant="bodyPrimaryReg">
            Your account will be{" "}
            <span style={{ fontWeight: 600 }}>
              downgraded {currentPlanLabel ? `from ${currentPlanLabel} ` : ""}to
              Free
            </span>{" "}
            unless a new payment method is added. If you don't want to
            downgrade, you can update your billing information instead.
          </Typography>
        )}
        <Typography
          variant="bodySecondaryReg"
          sx={{ color: "shades.neutral.600" }}
        >
          {currentPlanLabel}
          {inTrialPeriod ? " (free trial)" : null}
          {currentPlanLabel ? " features" : "Features"} will be available{" "}
          {inTrialPeriod
            ? "until your trial ends"
            : "through the end of your current billing period"}
          {currentPeriodEnd
            ? `, ${DateTime.fromISO(currentPeriodEnd).toFormat("LLLL d, yyyy")}`
            : ""}
          .
        </Typography>
      </Stack>
    </ConfirmationModal>
  );
};

export default RemovePaymentConfirmationModal;
